import React, { Fragment, useEffect, useState } from 'react';
import {
    BringzzTopBar,
    BringzzCategoryBox,
    BringzzBoxSlider,
    BringzzCallToAction,
    BringzzBottomDrawer,
    BringzzBasketDrawer,
    BringzzShimmer
} from "@bringzz/components";
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import BringzzLogo from 'assets/BringzzLogo.png';
import WomanCallToAction from 'assets/images/WomanCallToAction.png';
import ManCallToAction from 'assets/images/ManCallToAction.png';
import AddressSelect from '../../components/AddressSelect';
import { useTheme } from 'context/ThemeContext';
import RecommendationBox from '../../components/RecommendationBox';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '../../context/NavigationContext';
import { useOrder } from 'context/OrderContext';
import { useBookmark } from 'context/BookmarkContext';
import { usePosting } from 'context/PostingContext';
import PostingCardElement from "../../components/BringzzPostingCardElement";
import PostingCardSkeleton from "../../components/PostingCardSkeleton";
import { toast } from 'react-toastify';

import useHomepagePolling from 'hooks/useHomepagePolling';

// TODO: move all logic of fetching posts/bookmarks/orders to when user is logged in or when user accesses the app
const StaticContent = ({ onAddToCart, navigate, userAddress, setShowingAddressSelect, hasUnreadNotifications }) => {
    const { t } = useTranslation();
    return (
        <>
            <BringzzTopBar
                sections={[
                    { name: 'logo', alignment: 'start', value: BringzzLogo },
                    {
                        name: 'location',
                        alignment: 'center',
                        value: userAddress ? userAddress : t('component.home.address.select'),
                        onClick: () => setShowingAddressSelect(true),
                        className: 'cursor-pointer',
                        style: { cursor: 'pointer' }
                    },
                    {
                        name: 'notification',
                        alignment: 'end',
                        value: hasUnreadNotifications,
                        onClick: () => navigate('/notifications')
                    }
                ]}
            />
            {/* <BringzzPromoBanner
                header={t('component.home.promo_banner.header')}
                subHeader={
                    <>
                        {t('component.home.promo_banner.subheader')}{' '}
                        <span className='underline'>{t('component.home.promo_banner.terms')}</span>
                    </>
                }
            /> */}
        </>
    );
};

const AddressLoadingState = () => (
    <div className="flex items-center space-x-2 py-2">
        <BringzzShimmer width="20px" height="20px" rounded={true} />
        <BringzzShimmer width="200px" height="20px" />
    </div>
);

const ConsumerHomepage = () => {
    const { navigate } = useNavigation();
    const { isMobile } = useTheme();
    const { t } = useTranslation();

    const [showingAddressSelect, setShowingAddressSelect] = useState(false);
    const [showingDrawer, setShowingDrawer] = useState(false);
    const [userAddress, setUserAddress] = useState(null);

    const getFormattedAddress = (address) => {
        if (!address) return t('component.home.address.select');
        const streetPart = [address.streetName, address.houseNumber].filter(Boolean).join(' ');
        const cityPart = [address.postalCode, address.cityName].filter(Boolean).join(' ');
        return [streetPart, cityPart].filter(Boolean).join(', ');
    };
    const [showOpenBasketBottomSheet, setOpenBasketBottomSheet] = useState(false);
    const { sendRequest } = useRequest();
    const { user, updateUserAddresses } = useAuth();
    const order = useOrder()

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryProducts, setCategoryProducts] = useState([]);
    const [loadingCategory] = useState(false);

    const handleCategorySelect = (keyword) => {
        navigate(`/search?category=${encodeURIComponent(keyword)}`);
    };

    const closeCategoryModal = () => {
        setSelectedCategory(null);
        setCategoryProducts([]);
    };

    const categories = [
        {
            labelKey: 'component.home.categories.hearing_protection',
            keyword: 'Gehörschutz',
            icon: 'IconDeaf'
        },
        {
            labelKey: 'component.home.categories.naturlich',
            keyword: 'natürlich',
            icon: 'IconForest'
        },
        {
            labelKey: 'component.home.categories.griffonia_extract',
            keyword: 'Griffonia Extrakt',
            icon: 'IconPill1'
        },
        {
            labelKey: 'component.home.categories.protection_masks',
            keyword: 'Schutzmaske',
            icon: 'IconPpeMask'
        },
        {
            labelKey: 'component.home.categories.respiratory_masks',
            keyword: 'Atemschutzmaske',
            icon: 'IconRespirator'
        }
    ];
    const closeAddressSelection = () => {
        setShowingDrawer(false);

        // wait for drawer animation animation to finish
        setTimeout(() => {
            setShowingAddressSelect(false);
        }, 500);
    };
    const onAddToCart = (productId, quantity) => {
        console.log('added to cart ', productId);
        setOpenBasketBottomSheet(true);
    };
    const [posts, setPosts] = useState([])
    const [pageLoading, isLoading] = useState(true)
    const [closestPharmacy, setClosestPharmacy] = useState(null)
    const { collections, setBookmarksData, setCollectionsData } = useBookmark();
    const { setAllPostsData } = usePosting();

    const createChat = async () => {
        try {
            let closestPharmacyData = null;

            if (!closestPharmacy || !closestPharmacy.owner_id) {

                const closestPharmacyResponse = await sendRequest({
                    method: "GET",
                    url: "/module/getClosestPharmacyToUserAddress/pharmacy",
                });
                console.log("Fetched Response:", closestPharmacyResponse);
                if (closestPharmacyResponse.status === "success") {
                    setClosestPharmacy(closestPharmacyResponse.data.pharmacy);
                    closestPharmacyData = closestPharmacyResponse.data.pharmacy;
                } else {
                    console.error("Failed to fetch the closest pharmacy");
                }
            }

            if ((closestPharmacy && closestPharmacy.owner_id) || (closestPharmacyData && closestPharmacyData.owner_id)) {
                const ownerId = closestPharmacy?.owner_id ? closestPharmacy?.owner_id : closestPharmacyData?.owner_id;

                if (ownerId) {
                    navigate(`/settings/chats/${ownerId}`);
                } else {
                    console.error("Error creating chat with pharmacy:", ownerId);
                }
            } else {
                toast.error('There are no pharmacies near you');
            }
        } catch (err) {
            console.error("Error creating chat with pharmacy:", err);
        }
    };

    const callPharmacy = async () => {
        try {
            let closestPharmacyData = null;

            if (!closestPharmacy || !closestPharmacy.telefon) {

                const closestPharmacyResponse = await sendRequest({
                    method: "GET",
                    url: "/module/getClosestPharmacyToUserAddress/pharmacy",
                });
                console.log("Fetched Response:", closestPharmacyResponse);
                if (closestPharmacyResponse.status === "success") {
                    setClosestPharmacy(closestPharmacyResponse.data.pharmacy);
                    closestPharmacyData = closestPharmacyResponse.data.pharmacy;
                } else {
                    console.error("Failed to fetch the closest pharmacy");
                }
            }

            if ((closestPharmacy && closestPharmacy.telefon) || (closestPharmacyData && closestPharmacyData.telefon)) {
                const telefon = closestPharmacy?.telefon ? closestPharmacy?.telefon : closestPharmacyData?.telefon;

                window.location.href = `tel:${telefon.replace(/\s/g, "")}`;
            } else {
                toast.error('There are no pharmacies near you');
            }
        } catch (err) {
            console.error("Error creating chat with pharmacy:", err);
        }
    };

    useEffect(() => {
        const stored = localStorage.getItem('activeAddress');
        if (stored) {
            try {
                JSON.parse(stored);
                // Address will be handled by AddressContext
            } catch (e) {
                console.error('Failed to parse activeAddress from localStorage:', e);
            }
        }

        const fetchPosts = async () => {
            try {
                const postsRes = await sendRequest({
                    method: 'GET',
                    url: `/module/post/getAllPosts`,
                });

                if (postsRes.status === 'success') {
                    const posts = Array.isArray(postsRes.data.posts) ? postsRes.data.posts : [];
                    setPosts(posts);
                    setAllPostsData(posts);

                    if (postsRes.data.bookmarks) {
                        setBookmarksData(postsRes.data.bookmarks);
                    }
                    if (postsRes.data.collections) {
                        setCollectionsData(postsRes.data.collections);
                    }
                }

                isLoading(false);
            } catch (error) {
                console.error('Error preparing data:', error);
                isLoading(false);
            }
        }
        fetchPosts()
    }, [])

    // Using the new polling manager for active orders and notifications
    const [activeOrderData, setActiveOrderData] = useState(null);
    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

    useHomepagePolling({
        enabled: true,
        activeOrders: {
            enabled: true,
            interval: 30000, // Poll every 30 seconds
            immediate: true,
            onSuccess: (orderData) => {
                setActiveOrderData(orderData);
                // The polling hook already handles updating the order context
            }
        },
        notifications: {
            enabled: true,
            interval: 45000, // Poll every 45 seconds
            immediate: true,
            onSuccess: (data) => {
                setHasUnreadNotifications(data.hasUnread);
            }
        }
    });

    useEffect(() => {
        if (user?.activeAddress) {
            setUserAddress(getFormattedAddress(user.activeAddress));
        } else {
            setUserAddress(t('component.home.address.select'));
        }
    }, [user?.activeAddress, t]);

    return (
        <Fragment>
            <div>
                {/* Static content that loads immediately */}
                <StaticContent
                    onAddToCart={onAddToCart}
                    navigate={navigate}
                    userAddress={userAddress}
                    setShowingAddressSelect={setShowingAddressSelect}
                    hasUnreadNotifications={hasUnreadNotifications}
                />
                <div className=''>
                    {/* <BringzzBoxSlider
                        behavior={{ xl: 'left', m: 'left' }}
                        className='h-[69px] space-x-2 px-2 items-center py-3'
                        firstItemDivider={{ className: 'border border-magic-lilac' }}
                    >
                        <BringzzCategoryBox
                            left={{ icon: 'IconMegaphone2', folder: 'LineIcons' }}
                            className='bg-magic-lilac'
                        ></BringzzCategoryBox>

                        {categories.map((category, index) => (
                            <BringzzCategoryBox
                                key={index}
                                left={{ icon: category.icon, folder: 'HealthIcons' }}
                                label={t(category.labelKey)}
                                className='bg-sand'
                                onClick={() => handleCategorySelect(category.keyword)}
                            />
                        ))}

                        <BringzzCategoryBox
                            label={t('component.home.categories.show_all')}
                            className='bg-lemon-yellow'
                            onClick={() => navigate('/search')}
                        >
                            {t('component.home.categories.show_all')}
                        </BringzzCategoryBox>
                    </BringzzBoxSlider> */}
                    <BringzzCallToAction
                        text={t('component.home.cta.prescription.text')}
                        primaryButton={{
                            label: t('component.home.cta.prescription.button'),
                            className: 'bg-lemon-yellow text-olive-green',
                            onClick: () => navigate('/scan')
                        }}
                        image={WomanCallToAction}
                    />
                    {/* <RecommendationBox addToCart={onAddToCart} /> */}
                    <BringzzCallToAction
                        text={t('component.home.cta.pharmacist.text')}
                        primaryButton={{
                            label: t('component.home.cta.pharmacist.buttons.chat'),
                            className: 'bg-lemon-yellow text-olive-green',
                            onClick: () => createChat()
                        }}
                        secondaryButton={{
                            label: t('component.home.cta.pharmacist.buttons.call'),
                            className: 'bg-lemon-yellow text-olive-green',
                            onClick: () => callPharmacy()
                        }}
                        image={ManCallToAction}
                    />

                </div>

                {/* Active order tracking is handled by ProgressOverlay component */}

                {/* Dynamic content with loading states */}
                {/* {!activeAddress && <AddressLoadingState />} */}

                {/* <button onClick={() => {
                    window.location.href = 'https://192.168.178.194:8443'
                }}>Go to socket</button> */}

                {/* Posts section */}
                <div className="mt-4">
                    {pageLoading ? (
                        // Show 3 skeleton loading cards while loading
                        <>
                            <PostingCardSkeleton />
                            <PostingCardSkeleton />
                            <PostingCardSkeleton />
                        </>
                    ) : (
                        Array.isArray(posts) && posts.map((post, index) => (
                            <PostingCardElement
                                key={index}
                                post={post}
                                user={user}
                                preview={false}
                                collections={collections}
                            />
                        ))
                    )}
                </div>

                {/* Promo card at the bottom */}
                {/* <BringzzPromoCard
                    title='Ad/Promo Card headline lorem ipsum dolor sit amet est'
                    subTitle='Ultrices nunc dolor purus libero metus tincidunt iaculis. Neque ultrices.'
                    backgroundImage={PromoCardBackground}
                /> */}

                {/* Basket drawer */}
                <BringzzBasketDrawer
                    isOpen={showOpenBasketBottomSheet}
                    continueShoppingBtn={() => setOpenBasketBottomSheet(false)}
                    goToBasketBtn={() => navigate('/basket')}
                    basketContainerProps={{ className: 'min-h-32' }}
                    products={[
                        {
                            imgUrl: '/product.png',
                            price: 1.2,
                            quantity: 1
                        }
                    ]}
                />

                {/* Address selection drawer */}
                {showingAddressSelect && (
                    <BringzzBottomDrawer
                        isOpen={true}
                        close={closeAddressSelection}
                        title={t('component.home.address.select_to_continue')}
                    >
                        <AddressSelect
                            close={closeAddressSelection}
                            setAddress={setUserAddress}
                            onAddressUpdated={async () => {
                                await updateUserAddresses();
                            }}
                            activeAddress={user?.activeAddress}
                        />
                    </BringzzBottomDrawer>
                )}
                {selectedCategory && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                            <div className="flex justify-between items-center p-6 border-b">
                                <h2 className="text-2xl font-bold text-gray-800">
                                    {categories.find(c => c.keyword === selectedCategory)?.labelKey && t(categories.find(c => c.keyword === selectedCategory).labelKey)}
                                </h2>
                                <button
                                    onClick={closeCategoryModal}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    ✕
                                </button>
                            </div>
                            {loadingCategory && (
                                <div className="flex-1 flex items-center justify-center p-8">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                                </div>
                            )}
                            <div className="flex-1 overflow-y-auto p-6">
                                {categoryProducts.length > 0 ? (
                                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                        {categoryProducts.map((product, index) => (
                                            <div
                                                key={index}
                                                className="group relative bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                                            >
                                                <img
                                                    src={product.productImage || '/BringzzLogo.png'}
                                                    alt={product.productName}
                                                    className="w-full h-48 object-contain mb-4 rounded-lg"
                                                />
                                                <h3 className="font-bold text-900 mb-2">
                                                    {product.productName}
                                                </h3>
                                                <div className="flex justify-between items-center">
                                                    <span className="text-lg font-bold text-purple-600">
                                                        €{product.price.toFixed(2)}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    !loadingCategory && (
                                        <div className="text-center py-8 text-gray-500">
                                            {t('component.home.modal.no_products')}
                                        </div>
                                    )
                                )}
                            </div>
                            <div className="p-4 border-t">
                                <button
                                    onClick={closeCategoryModal}
                                    className="w-full py-3 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg transition-colors"
                                >
                                    {t('component.home.modal.close')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Fragment>
    );
}

export default ConsumerHomepage;